import { Navigate, Outlet, matchPath, useLocation } from 'react-router-dom'
import { useRoles } from '@/hooks/auth'
import { Role } from '@/constants/role'
import Tabs from '@/components/Tabs'

const HOME = '/troas/roas'
// Every Roaser sees the tabs without `buyer`; buyers see all of them.
const tabs = [
  { name: 'Roas', to: HOME },
  { name: '投放数据盘', to: '/troas/data-dashboard' },
  { name: 'Campaigns', to: '/troas/campaigns', buyer: true },
  { name: 'DayN ROAS', to: '/troas/day0-roas', buyer: true },
  { name: 'Notes', to: '/troas/notes', buyer: true },
  { name: 'Revenue Structure', to: '/troas/rs', buyer: true },
  { name: 'Revenue by Age', to: '/troas/rs-age', buyer: true },
  { name: 'Summary', to: '/troas/summary', buyer: true },
  { name: 'Report', to: '/troas/report', buyer: true },
  { name: 'Recovery', to: '/troas/recovery', buyer: true },
  // { name: 'Revenues Snapshot', to: '/troas/revenues-snapshot', buyer: true },
]

const Layout = () => {
  const location = useLocation()
  const isRoaser = useRoles([Role.Roaser])
  const isBuyer = useRoles([Role.Buyer, Role.BuyerLeader])
  if (!isRoaser) {
    return <Navigate to="/403" />
  }
  const visibleTabs = isBuyer ? tabs : tabs.filter((tab) => !tab.buyer)
  const allowed =
    isBuyer ||
    visibleTabs.some((tab) =>
      matchPath({ path: tab.to, end: false }, location.pathname),
    )
  if (!allowed) {
    return <Navigate to={HOME} replace />
  }
  return (
    <div className="flex flex-col gap-4">
      <div className="overflow-x-auto">
        <div className="min-w-max [&_a]:whitespace-nowrap">
          <Tabs datas={visibleTabs} />
        </div>
      </div>
      <Outlet />
    </div>
  )
}

export default Layout
